export default "__VITE_ASSET__Bskgw4EB__"